import ReactDOM from 'react-dom';
import './index.css';
import React, { useState } from 'react';
import axios from 'axios';

function LanguageBox(props) {
	let style = {
		marginBottom: '20px',
		backgroundColor: 'lightblue'
	}

	return <div style={style}>
		<p>{props.name}</p>
		<p>{props.description}</p>
	</div>
}

function LanguageList(props) {
	let style = {
		display: 'flex',
		flexDirection: 'column'
	}

	if (props.languages.length > 0) {
		return <div style={style}>
			{props.languages.map(lang => 
				<LanguageBox
					key={Math.random()}
					name={lang.name}
					description={lang.description}
				/>
			)}
		</div>
	} else {
		return <div>
			<p>Language not found</p>
		</div>
	}
}

function App() {
	const [search, updateSearch] = useState('');
	const [searchResults, updateSearchResults] = useState([]);
	const [searched, updateSearched] = useState(false);

	function searchRequest() {
		console.log(`https://ctf1-api.vercel.app/search?name=${search}`)
		axios.get(`https://ctf1-api.vercel.app/search?name=${search}`).then((response) => {
			updateSearchResults(response.data)
			updateSearched(true);
		})
	}

	let emptyDiv = <div></div>;

	return (
		<div>
			<div>
				<input onChange={e => updateSearch(e.target.value)}/>
				<button onClick={() => searchRequest()}>Search</button>
			</div>

			<div>
				{searched === false ? emptyDiv : 
					<LanguageList languages={searchResults} />
				}
			</div>
		</div>
	)
}


ReactDOM.render(
	<App />,
	document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js